import * as yup from "yup";

export function buildTourValidationSchema(activeIsos = []) {
  const requiredIsos = activeIsos.includes("en") ? ["en"] : [];
  const buildLocalizedShape = () =>
    activeIsos.reduce((acc, iso) => {
      acc[iso] =
        iso === "en"
          ? yup.string().trim().required("EN is required.")
          : yup.string().nullable().transform(() => "");
      return acc;
    }, {});

  return yup.object({
    countryId: yup.string().trim().required("Country is required."),
    cityId: yup.string().trim().required("City is required."),
    status: yup.number().required("Status is required."),
    isActive: yup.boolean().required("Active flag is required."),
    bannerId: yup.string().trim().required("Banner is required."),
    snapshotId: yup.string().trim().required("Tour snapshot image is required."),
    tourImages: yup.array().of(yup.string().trim().required()),
    tourImagesCount: yup.number().min(1, "At least one tour image is required.").required("At least one tour image is required."),
    promoVideoCount: yup.number().min(requiredIsos.length, "English must include one promo video.").required("English must include one promo video."),
    promoAudioCount: yup.number().min(requiredIsos.length, "English must include one promo audio.").required("English must include one promo audio."),
    promoAudioTitlesValid: yup.boolean().oneOf([true], "English promo audio must include a title.").required("English promo audio must include a title."),
    country: yup.object().shape(buildLocalizedShape()).required("Country is required."),
    buttonTitle: yup.object().shape(activeIsos.reduce((acc, iso) => { acc[iso] = yup.string().nullable().transform(() => ""); return acc; }, {})),
    badgeTitle: yup.object().shape(activeIsos.reduce((acc, iso) => { acc[iso] = yup.string().nullable().transform(() => ""); return acc; }, {})),
    region: yup.object().shape(buildLocalizedShape()).required("Region is required."),
    city: yup.object().shape(buildLocalizedShape()).required("City is required."),
    name: yup.object().shape(buildLocalizedShape()).required("Name is required."),
    description: yup.object().shape(buildLocalizedShape()).required("Description is required."),
    duration: yup.object().shape(buildLocalizedShape()).required("Duration is required."),
    pointCount: yup.number().integer("Point count must be an integer.").min(0, "Point count cannot be negative.").required("Point count is required."),
    stopCount: yup.number().integer("Stop count must be an integer.").min(0, "Stop count cannot be negative.").required("Stop count is required."),
  });
}
